<template>
  <el-dialog
    class="dialogImageLibrary"
    width="1028px"
    :visible="true"
    append-to-body
    :close-on-press-escape="false"
    @close="$emit('close')">
    <div
      slot="title"
      class="d-flex align-items-center justify-content-between pb-2 px-3 py-2"
      style="margin-top: -10px">
      <div class="d-flex align-items-center mt-2">
        <span class="font-16 fw-700">Thư viện tài liệu</span>
        <!-- <el-select
          class="ms-3"
          v-model="selectAccountId"
          @change="onChangeAccountId"
          filterable
          default-first-option
          placeholder="Chọn thư viện"
          size="small"
          style="max-width: 160px">
          <el-option
            :key="0"
            label="Thư viện chung"
            :value="'0'"></el-option>
          <el-option
            v-for="account in accounts"
            :key="account.accountId"
            :label="getAccountName(account)"
            :value="account.accountId"></el-option>
        </el-select> -->
      </div>
      <div class="d-flex mt-2 me-4">
        <div
          v-for="(img, index) in selectShow"
          :key="img.name"
          class="d-flex align-items-center py-1 px-1 rounded-2 border me-2"
          style="background-color: #f4f5f9">
          <span
            class="trim-text-1-line pointer font-14 fw-400 text-grey700"
            style="max-width: 155px">
            {{ img.name }}
          </span>
          <div
            class="pointer"
            @click="removeImage(index, 'show')">
            <IconV2 name="v2-close" />
          </div>
        </div>
        <el-popover
          v-if="selectHide.length"
          width="100px"
          trigger="hover">
          <div
            slot="reference"
            class="d-flex align-items-center py-1 px-1 rounded-2 border me-2"
            style="background-color: #f4f5f9">
            <span class="font-14 fw-400 text-grey700">+{{ selectHide.length }}</span>
          </div>
          <div
            v-for="(img, index) in selectHide"
            :key="img.name"
            class="d-flex align-items-center my-1 py-1 px-1 rounded-2 border me-2"
            style="background-color: #f4f5f9">
            <span
              class="trim-text-1-line pointer font-14 fw-400 text-grey700"
              style="max-width: 155px">
              {{ img.name }}
            </span>
            <div
              class="pointer"
              @click="removeImage(index, 'hide')">
              <IconV2 name="v2-close" />
            </div>
          </div>
        </el-popover>
      </div>
    </div>

    <div
      class="d-flex mx-12 rounded-2 border"
      style="height: 488px">
      <div
        class="px-2 py-12"
        style="width: 230px; background-color: #fafafa">
        <div class="d-flex mb-2 gap-2">
          <el-input
            v-model="searchKey"
            placeholder="Tìm thư mục, hình ảnh"
            size="small">
            <IconV2
              slot="prefix"
              class="my-2 mx-1"
              name="v2-search" />
          </el-input>
          <el-button
            type="primary"
            style="border-radius: 4px; padding: 4px 12px"
            @click="dialogCreateFolder = true">
            <div>
              <IconV2
                color="#ffffff"
                slot="prefix"
                name="v2-add" />
            </div>
          </el-button>
        </div>
        <div style="max-height: 420px; overflow-y: auto">
          <div
            style="height: 36px"
            @click="getFilesOutFolder()"
            :class="{ 'folder-active': isFilesOutFolder && !isClicked }"
            class="out-folder p-1 me-2 d-flex align-items-center font-14 fw-400 text-grey700 rounded-2 folder-item pointer">
            <IconV2
              slot="prefix"
              size="17px"
              class="my-2 mx-1"
              name="v2-grid" />
            Ngoài thư mục
          </div>
          <div
            v-for="folder in foldersView"
            :key="folder.id"
            ref="folderItems"
            style="height: 36px"
            class="px-2 me-2 d-flex align-items-center font-14 fw-400 text-grey700 rounded-2 folder-item pointer"
            :class="{ 'folder-active': selectFolder && selectFolder.id === folder.id && !isClicked && !isFilesOutFolder }"
            @click="onSelectFolder(folder)">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="d-flex folder-info flex-grow-1 align-items-center">
                <IconV2 name="v2-folder" />
                <span
                  class="ms-2 trim-text-1-line"
                  style="max-width: 130px">
                  {{ folder.name }}
                </span>
              </div>
              <IconV2
                v-if="folder.favourite"
                slot="prefix"
                color="#FFCC00"
                name="fa-solid fa-star" />
            </div>
          </div>
        </div>
      </div>

      <!--Display File In Folder-->
      <div
        class="px-2 py-12 flex-1"
        @drop.stop.prevent="handleDrop"
        @dragover.prevent=""
        @dragleave.prevent=""
        draggable="true">
        <div class="d-flex align-items-center justify-content-between flex-1 px-1">
          <div>
            <span
              v-if="isClicked"
              class="font-14 fw-500 text-grey700 text-grey700 trim-text-1-line"
              style="max-width: 350px">
              {{ folderName }}
            </span>
            <div v-else>
              <span
                v-if="isFilesOutFolder"
                class="font-14 fw-500 text-grey700 text-grey700 trim-text-1-line">
                Ngoài thư mục
              </span>
              <div
                class="d-flex align-items-center gap-2"
                v-else>
                <span
                  class="font-14 fw-500 text-grey700 trim-text-1-line"
                  style="max-width: 350px">
                  {{ selectFolder.name }}
                </span>
                <IconV2
                  v-if="selectFolder.favourite"
                  slot="prefix"
                  color="#FFCC00"
                  name="fa-solid fa-star" />
              </div>
            </div>
          </div>
          <div class="d-flex gap-2">
            <el-button
              type="primary"
              size="small"
              @click="selectAllImage()">
              Chọn tất cả
            </el-button>
            <el-upload
              class="font-14 fw-400 d-flex align-items-center px-2 rounded-2"
              style="height: 32px; border: thin dashed #dcdfe9"
              :action="getUploadUrl(folderId)"
              :headers="getUploadHeader()"
              :show-file-list="false"
              :file-list="fileList"
              :on-change="fileChanged"
              :on-success="imageUploaded"
              :on-error="imageUploadFailed"
              multiple>
              Kéo thả tài liệu hoặc
              <span class="text-blue400 ms-1 pointer">bấm để thêm mới</span>
            </el-upload>
          </div>
        </div>

        <div
          v-if="(!imagesView.length && !isLoading) || isClicked"
          class="d-flex flex-column align-items-center justify-content-center flex-1 h-100">
          <img src="/assets/images/img-folder-empty.svg" />
          <span class="font-13 text-grey600">Thư mục chưa có ảnh</span>
        </div>
        <div
          v-if="!imagesView.length && !isClicked && isLoading"
          class="d-flex flex-column gap-2 align-items-center justify-content-center flex-1 h-100">
          <div class="loader"></div>
          <span class="font-size-16">Đang tải . . .</span>
        </div>
        <div
          v-if="imagesView.length && !isClicked && !isLoading"
          class="img-library-containter">
          <ImageLibraryV2
            v-for="img in imagesView"
            :key="img.id"
            :img="img"
            @openGallery="openGallery(img.id)" />
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-content-end py-12 px-12">
        <el-button
          type="info"
          size="small"
          @click="$emit('close')">
          Hủy
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="send">
          Gửi
          <span v-if="totalSend">({{ totalSend }})</span>
        </el-button>
      </div>
    </div>

    <el-dialog
      class="dialogCreateFolder"
      v-if="dialogCreateFolder"
      :visible="true"
      append-to-body
      width="500px"
      :close-on-press-escape="false"
      @close="resetNewFolder">
      <div
        slot="title"
        class="font-16 fw-500 text-center">
        Tạo thư mục mới
      </div>
      <div class="px-3">
        <div class="w-100 d-flex flex-column mb-2">
          <span class="text-dark fw-bold">Tài khoản</span>
          <el-select
            class="mt-1"
            v-model="selectAccountId"
            filterable
            default-first-option
            placeholder="Chọn thư viện"
            size="small">
            <el-option
              :key="0"
              label="Tất cả tài khoản"
              :value="'0'"></el-option>
            <el-option
              v-for="account in accounts"
              :key="account.accountId"
              :label="getAccountName(account)"
              :value="account.accountId"></el-option>
          </el-select>
        </div>
        <div>
          <span class="text-dark fw-bold">
            Tên thư mục
            <span class="text-danger">*</span>
          </span>
          <el-input
            class="mt-1"
            size="small"
            placeholder="Tối đa 50 ký tự"
            v-model="folderName"
            maxlength="50"></el-input>
        </div>
        <div class="d-flex align-items-center mt-2 w-100">
          <div class="fw-bold text-dark w-25">Tải lên tệp tin</div>
          <div
            class="d-flex align-items-center w-75"
            @click="openFileInput">
            <div class="w-100">
              <el-input>
                <template #append>Chọn tệp tin</template>
              </el-input>
            </div>
          </div>
        </div>
        <div
          v-if="fileUploadInFolderList.length"
          class="d-flex align-items-center mt-2">
          <IconV2
            name="v2-check"
            color="green"></IconV2>
          <span class="flex-grow-1 ms-1">
            Đã chọn
            <span class="fw-bold text-primary">{{ fileUploadInFolderList.length }}</span>
            tệp tin mới
          </span>
        </div>

        <input
          style="display: none"
          @change="onFileChanged"
          type="file"
          ref="inputUpload"
          multiple
          hidden />
      </div>
      <div class="d-flex justify-content-end py-12 px-12">
        <el-button
          type="info"
          size="small"
          @click="resetNewFolder">
          Hủy
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="createFolder">
          Tạo
        </el-button>
      </div>
    </el-dialog>
    <LightBox
      ref="lightbox"
      :media="imageMedia"
      :show-caption="true"
      :show-light-box="false" />
  </el-dialog>
</template>

<script>
/* eslint-disable */
import { HTTP } from "@/lib/http-common";
import Config from "@/lib/Config";
import { getFileExtension, removeVietnameseTones } from "../lib/text-utils";
import LightBox from "./common/LightBox/LightBox";
import ImageLibraryV2 from "./ImageLibraryV2.vue";

export default {
  props: ["conversation"],
  components: { LightBox, ImageLibraryV2 },
  data() {
    return {
      folderId: 0,
      folderName: "",
      accountId: "",
      searchKey: "",
      accounts: [],
      selectAccountId: "0",
      folders: [],
      selectFolder: {},
      images: [],
      files: [],
      fileList: [],
      dialogCreateFolder: false,
      nameFolder: "",
      fileUploadInFolderList: [],
      isClicked: false,
      isLoading: false,
      isFilesOutFolder: false,
      isCreate: false,
    };
  },
  computed: {
    foldersView() {
      return this.folders.filter((f) => removeVietnameseTones(f.name).includes(removeVietnameseTones(this.searchKey)));
    },
    imagesView() {
      return this.images.filter((img) => removeVietnameseTones(img.name).includes(removeVietnameseTones(this.searchKey)));
    },
    imageMedia() {
      return this.imagesView.filter((media) => media.type === "image");
    },
    filesView() {
      return this.files.filter((file) => removeVietnameseTones(file.name).includes(removeVietnameseTones(this.searchKey))).reverse();
    },
    selectImage() {
      return this.images.filter((img) => img.isSelect && img.type === "image");
    },
    selectFile() {
      return this.images.filter((file) => file.isSelect && file.type === "file");
    },
    selectShow() {
      const list = [...this.selectImage, ...this.selectFile];
      if (list.length < 3) return list;
      return list.filter((img, i) => i < 2);
    },
    selectHide() {
      const list = [...this.selectImage, ...this.selectFile];
      if (list.length < 3) return [];
      return list.filter((img, i) => i > 1);
    },
    totalSend() {
      return this.selectImage.length + this.selectFile.length;
    },
  },
  watch: {
    folders: {
      handler(newFolders) {
        if (newFolders.length === 0) {
          this.getFilesOutFolder();
        } else {
          this.isFilesOutFolder = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    selectAllImage() {
      return this.images.forEach((img) => {
        img.isSelect = true;
      });
    },
    openGallery(id) {
      const imageIndex = this.imageMedia.findIndex((media) => media.id === id);
      if (imageIndex !== -1) {
        this.$refs.lightbox.showImage(imageIndex);
      } else {
        console.error("Image not found in imageMedia");
      }
    },
    getAccounts() {
      HTTP.get("/api/account").then((resp) => {
        if (resp.status === "success") {
          this.accounts = resp.data;
        }
      });
    },
    fetchFolders() {
      this.$http
        .get("/api/v2/folder?accountId=" + this.selectAccountId)
        .then((response) => {
          this.folders = response.data.map((s) => {
            s.isCommon = this.selectAccountId ? false : true;
            return s;
          });
          if (this.folders.length) {
            this.onSelectFolder(this.selectFolder.id ? this.selectFolder : this.folders[0]);
          } else {
            this.onSelectFolder({});
          }
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra");
        });
    },
    async fetchAllFolders() {
      try {
        const response1 = await this.$http.get("/api/v2/folder?accountId=0");
        this.folders = response1.data.map((s) => {
          s.isCommon = true;
          return s;
        });
        if (!this.isCreate) {
          if (this.folders.length) {
            this.onSelectFolder(this.selectFolder.id ? this.selectFolder : this.folders[0]);
          }
        }
        const response2 = await this.$http.get("/api/v2/folder?accountId=" + this.conversation.accountId);
        this.folders = [
          ...this.folders,
          ...response2.data.map((s) => {
            s.isCommon = this.conversation.accountId ? false : true;
            return s;
          }),
        ];
        if (!this.isCreate) {
          if (this.folders.length) {
            this.onSelectFolder(this.selectFolder.id ? this.selectFolder : this.folders[0]);
          }
        }
      } catch (error) {
        this.alert("error", "Có lỗi xảy ra");
      }
    },
    fetchImages() {
      this.isLoading = true;
      this.$http
        .get("/api/v2/image?accountId=" + this.accountId + "&folderId=" + this.folderId)
        .then((response) => {
          this.images = response.data
            .sort((a, b) => new Date(b.createAt) - new Date(a.createAt))
            .map((img) => ({
              id: img.id,
              name: img.fileName,
              src: img.url,
              isSelect: false,
              thumb: img.url,
              type: img.contentType.startsWith("image/") ? "image" : "file",
              url: img.url,
            }));
          this.isLoading = false;
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra");
        });
    },
    getFilesOutFolder() {
      this.folderId = 0;
      this.accountId = this.conversation.accountId;
      this.images = [];
      this.isLoading = true;
      this.isClicked = false;
      this.isFilesOutFolder = true;
      this.selectFolder = {};
      this.fetchImages();
    },
    onSelectFolder(folder) {
      this.folderId = folder.id;
      this.accountId = folder.account.accountId;
      this.selectFolder = folder;
      this.images = [];
      if (folder.id) {
        this.fetchImages();
      }
      this.isClicked = false;
      this.folderName = "";
      this.isFilesOutFolder = false;

      this.$nextTick(() => {
        const folderIndex = this.foldersView.findIndex((f) => f.id === folder.id);
        if (folderIndex !== -1) {
          const folderElement = this.$refs.folderItems[folderIndex];
          folderElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    },

    getFileThumb(file) {
      const extension = getFileExtension(file);
      switch (extension) {
        case "m4v":
        case "mp4":
        case "avi":
        case "mkv":
        case "wmv":
        case "flv":
        case "mov":
        case "3gp":
        case "3g2": {
          return "/assets/icon/icon-file-video.svg";
        }
        case "pdf": {
          return "/assets/icon/icon-file-pdf.svg";
        }
        case "zip": {
          return "/assets/icon/icon-file-zip.svg";
        }
        case "doc":
        case "docx":
        case "txt":
        case "odt":
        case "tex":
        case "xml":
        case "html": {
          return "/assets/icon/icon-file-doc.svg";
        }
        case "xlsx":
        case "xls":
        case "xlsm":
        case "xlsb": {
          return "/assets/icon/icon-file-excel.svg";
        }
        default:
          return "/assets/icon/icon-file-doc.svg";
      }
    },
    removeImage(index, listType) {
      if (listType === "show") {
        this.selectShow[index].isSelect = false;
      } else {
        this.selectHide[index].isSelect = false;
      }
    },
    onChangeAccountId() {
      this.fetchFolders();
      this.selectFolder = {};
    },
    async send() {
      if (!this.selectFile.length) {
        this.sendImgs();
      }
      if (!this.selectImage.length) {
        this.sendFiles();
      }
      if (this.selectImage.length && this.selectFile.length) {
        this.sendImgs();
        this.sendFiles();
      }
      this.$emit("close");
    },
    async sendImgs() {
      if (this.selectImage.length > 1) {
        let groupMsgId = new Date().getTime();
        let index = 0;
        for (let img of this.selectImage) {
          this.sendMsgPhoto(img.id, groupMsgId, this.selectImage.length, index);
          index += 1;
        }
      } else {
        this.sendMsgPhoto(this.selectImage[0].id, 0, 0, 0);
      }
    },
    async sendMsgPhoto(selectedImage, groupMsgId, totalItems, idInGroup) {
      await this.$http.get("/api/message/sendPhoto", {
        params: {
          conversationId: this.conversation.id,
          id: selectedImage,
          accountId: this.conversation.accountId,
          toId: this.conversation.group !== true ? this.conversation.toId : null,
          groupId: this.conversation.group === true ? this.conversation.toId : null,
          idInGroup: idInGroup,
          totalItems: totalItems,
          groupMsgId: groupMsgId,
        },
      });
    },
    async sendFiles() {
      this.selectFile.forEach((s) => {
        this.sendMsgFile(s.id);
      });
    },
    async sendMsgFile(id) {
      var bodyFormData = new FormData();
      bodyFormData.append("conversationId", this.conversation.id);
      bodyFormData.append("id", id);
      bodyFormData.append("accountId", this.conversation.accountId);
      bodyFormData.append("toId", this.conversation.toId);
      bodyFormData.append("isGroup", this.conversation.group);
      await this.$http.post("/api/message/sendFileFromLibrary", bodyFormData);
    },
    getUploadUrl(folderId) {
      let HOST = "";
      if (Config.DEV) {
        HOST = Config.HOST;
      } else {
        HOST = "https://zalo.salework.net";
      }
      return HOST + "/api/v2/image?accountId=" + this.accountId + "&folderId=" + folderId;
    },
    getUploadHeader() {
      let userToken = localStorage.getItem("userToken");

      return {
        Authorization: "Bearer " + userToken,
      };
    },
    fileChanged(file, fileList) {
      this.fileList = fileList;
    },
    imageUploaded() {
      this.alert("success", "Tải lên thành công");
      if (this.folderId == 0) {
        this.getFilesOutFolder();
      } else {
        this.fetchImages(this.selectFolder);
      }
    },
    imageUploadFailed(ex) {
      if (ex.toString().includes("not accept")) {
        return this.alert("error", "File tải lên quá lớn");
      }
      this.alert("error", "Có lỗi xảy ra");
    },
    async handleDrop(ev) {
      ev.preventDefault();
      if (ev.dataTransfer.items) {
        await Promise.all(
          [...ev.dataTransfer.items].map(async (item) => {
            const file = item.getAsFile();
            const form = new FormData();
            form.append("file", file);
            await this.$http.post("/api/v2/image?accountId=" + this.accountId + "&folderId=" + this.folderId, form);
            this.alert("success", "Tải lên thành công");
          })
        );
        if (this.folderId == 0) {
          this.getFilesOutFolder();
        } else {
          this.fetchImages();
        }
      } else {
        await Promise.all(
          [...ev.dataTransfer.files].map(async (item) => {
            const file = item.getAsFile();
            const form = new FormData();
            form.append("file", file);
            await this.$http.post("/api/v2/image?accountId=" + this.accountId + "&folderId=" + this.folderId, form);
            this.alert("success", "Tải lên thành công");
          })
        );
        if (this.folderId == 0) {
          this.getFilesOutFolder();
        } else {
          this.fetchImages();
        }
      }
    },

    openFileInput() {
      this.$refs.inputUpload.click();
    },

    async onFileChanged(e) {
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        this.fileUploadInFolderList.push(files[i]);
      }
      // for (let file of files) {
      //   this.readFile(file);
      // }
    },
    resetNewFolder() {
      this.fileUploadInFolderList = [];
      this.folderName = "";
      this.dialogCreateFolder = false;
    },
    readFile(file) {
      const reader = new FileReader();
      reader.onload = () => {
        const blob = new Blob([reader.result], { type: file.type });
        this.fileUploadInFolderList.push(blob);
      };
      reader.readAsArrayBuffer(file);
    },

    async createFolder() {
      this.isCreate = true;
      // if (!this.folderName || !this.fileUploadInFolderList.length) {
      //   return;
      // }
      if (this.folderName.trim().length === 0) {
        return this.alert("error", "Vui lòng nhập tên thư mục");
      }
      this.$http
        .post("/api/folder", {
          accountId: this.selectAccountId,
          id: 0,
          name: this.folderName,
        })
        .then(async (resp) => {
          const newFolder = resp.data;
          await Promise.all(
            this.fileUploadInFolderList.map(async (item) => {
              const form = new FormData();
              form.append("file", item);
              await this.$http.post("/api/v2/image?accountId=" + this.selectAccountId + "&folderId=" + newFolder.id, form);
            })
          );
          await this.fetchAllFolders(false).then(() => {
            const foundFolder = this.folders.find((folder) => folder.name === newFolder.name && folder.id === newFolder.id);
            if (foundFolder) {
              this.onSelectFolder(foundFolder);
              this.isCreate = false;
            } else {
              this.alert("error", "Không tìm thấy thư mục vừa tạo");
            }
          });
          this.dialogCreateFolder = false;
          this.folderName = "";
          this.fileUploadInFolderList = [];
          this.alert("success", "Tạo thư mục thành công");
        })
        .catch((e) => {
          if (e.error?.message.includes("dupplicate")) {
            return this.alert("error", "Tạo trùng tên thư mục");
          } else if (e.error?.message.includes("No Manage Permission")) {
            return this.alert("error", "Bạn chưa có quyền cài đặt và chỉnh sửa");
          } else {
            this.alert("error", "Có lỗi xảy ra");
          }
        });
    },
    getNameFile(name) {
      this.$http.get("/api/image/" + name).then((resp) => {
        let data = resp.data;
        return data.fileName || name;
      });
    },
  },
  mounted() {
    this.fetchAllFolders();
    this.getAccounts();
  },
};
</script>

<style lang="scss" scoped>
.loader {
  border: 10px solid #f3f3f3;
  border-radius: 50%;
  border-top: 10px solid #a3a7ab;
  border-bottom: 10px solid #a3a7ab;
  width: 80px !important;
  height: 80px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<style lang="scss" >
.dialogCreateFolder {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.dialogImageLibrary {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
  .folder-active {
    background-color: #e1edfd;
  }
  .folder-active .folder-info {
    color: #1769d7 !important;
    font-weight: 700;
    .icon-font {
      :before {
        color: #1769d7 !important;
      }
    }
  }
  .folder-item:hover {
    background-color: #e1edfd;
  }

  .out-folder.folder-active {
    color: #1769d7 !important;
    font-weight: 700;
    .icon-font {
      :before {
        color: #1769d7 !important;
      }
    }
  }

  .img-library-containter {
    max-height: 424px;
    overflow-y: auto;
    margin: 0.5rem 0 0 0;
    display: grid;
    max-width: 100%;
    gap: 4px;

    grid-template-columns: repeat(auto-fill, minmax(165px, 1fr));
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
    -webkit-scrollbar {
      display: none;
    }
  }
  .img-library-item {
    margin-bottom: 8px;
    margin-right: 4px;
    margin-left: 4px;
  }
  .img-active {
    border: thin solid #73afff !important;
  }
}
.input-add input {
  border: #eaecf2 1px dashed;
  background-color: #fafafa;
  font-size: 13px;
  height: 100%;
  border-radius: 4px 0 0 4px;
}
.input-add.is-click input {
  border: #eaecf2 1px solid;
  background-color: #ffffff;
}
</style>
